import { render, staticRenderFns } from "./IconSvgClowderLogo.vue?vue&type=template&id=20466afc&scoped=true&"
import script from "./IconSvgClowderLogo.vue?vue&type=script&lang=js&"
export * from "./IconSvgClowderLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20466afc",
  null
  
)

export default component.exports